<template>
    <div>
        <div id="custom_card" class="card sticky">
            <div class="grid justify-content-between">
                <div class="col-12 md:col-6">
                    <div
                        class="flex flex-wrap align-items-center justify-content-center md:justify-content-start md:mb-0 mb-3">
                        <p style="color: #3f51b5; font-size: 20px; font-weight: 800">
                            {{ $t("dash") }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid">
            <div class="col-12 lg:col-2 xl:col-2 " style="width: 20%; height: 100%">
                <div class="card mb-0" id="custom_card_shadow" @click="Go('/Application')">
                    <div class="flex justify-content-between mb-0">
                        <div>
                            <span class="block text-500 font-medium mb-3">{{
                                $t("total_applications")
                            }}</span>
                            <div class="text-5xl" style="color: #3f51b5; font-size: 20px; font-weight: 800">
                                {{ TotalApplicationCount }}
                            </div>
                        </div>
                        <div class="flex align-items-center justify-content-center bg-cyan-100 border-round"
                            style="width: 6rem; height: 5rem">
                            <i class="pi pi-envelope text-cyan-500 text-5xl"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-2 xl:col-2 " style="width: 20%; height: 100%">
                <div class="card mb-0" id="custom_card_shadow" @click="Go('/ward', 'closed')">
                    <div class="flex justify-content-between mb-0">
                        <div>
                            <span class="block text-500 font-medium mb-3">{{
                                $t("approved_application")
                                }}</span>
                            <div class="text-5xl" style="color: #3f51b5; font-size: 20px; font-weight: 800">
                                {{ ApprovedApplicationCount }}
                            </div>
                        </div>
                        <div class="flex align-items-center justify-content-center bg-purple-100 border-round"
                            style="width: 6rem; height: 5rem">
                            <i class="pi pi-list text-red-500 text-5xl"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-2 xl:col-2 " style="width: 20%; height: 100%">
                <div class="card mb-0" id="custom_card_shadow" @click="Go('/PendingApplication')">
                    <div class="flex justify-content-between mb-0">
                        <div>
                            <span class="block text-500 font-medium mb-3">{{
                                $t("pending_applications")
                            }}</span>
                            <div class="text-5xl" style="color: #3f51b5; font-size: 20px; font-weight: 800">
                                {{ PendingApplicationCount }}
                            </div>
                        </div>
                        <div class="flex align-items-center justify-content-center bg-cyan-100 border-round"
                            style="width: 6rem; height: 5rem">
                            <i class="pi pi-envelope text-cyan-500 text-5xl"></i>
                        </div>
                    </div>
                </div>
            </div>            
            <div class="col-12 lg:col-2 xl:col-2 " style="width: 20%; height: 100%">
                <div class="card mb-0" id="custom_card_shadow">
                    <div class="flex justify-content-between mb-0">
                        <div>
                            <span class="block text-500 font-medium mb-3">{{
                                $t("total_schemes")
                            }}</span>
                            <div class="text-5xl" style="color: #3f51b5; font-size: 20px; font-weight: 800">
                                {{ TotalScheme }}
                            </div>
                        </div>
                        <div class="flex align-items-center justify-content-center bg-orange-100 border-round"
                            style="width: 6rem; height: 5rem">
                            <i class="pi pi-table text-orange-500 text-5xl"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-2 xl:col-2 " style="width: 20%; height: 100%">
                <div class="card mb-0" id="custom_card_shadow" @click="Go('/tickets', 3)">
                    <div class="flex justify-content-between mb-0">
                        <div>
                            <span class="block text-500 font-medium mb-3">{{
                                $t("total_feedback")
                            }}</span>
                            <div class="text-5xl" style="color: #3f51b5; font-size: 20px; font-weight: 800">
                                {{ TotalFeedback }}
                            </div>
                        </div>
                        <div class="flex align-items-center justify-content-center bg-purple-100 border-round"
                            style="width: 6rem; height: 5rem">
                            <i class="pi pi-lock text-purple-500 text-5xl"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid">
            <div class="col-12 lg:col-12 xl:col-12">
                <div class="card ">
                    <span class="block text-500 font-medium mb-3">{{ $t("scheme_wise_application_count") }}</span>
                    <Chart type="pie" :data="chartData" :options="chartOptions" style="width: 500px; height: 500px;" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import apis from "@/apis";
import axios from "axios";
export default {
    name: "MahatakrarClerkDashboard",
    data() {
        return {
            chartData: null,
            chartOptions: null,
            PendingApplicationCount: 0,
            ApprovedApplicationCount: 0,
            TotalApplicationCount: 0,
            TotalScheme: 0,
            TotalFeedback: 0,
            SchemeList: [],
        };
    },
    computed: {
        currentLocale() {
            return this.$i18n.locale;
        },
    },
    watch: {
        currentLocale() {
            this.getSchemeWiseCount();
        }
    },
    async mounted() {
        //get pending application count
        this.chartData = await this.setChartData();
        this.chartOptions = await this.setChartOptions();
        this.GetPendingApplicationCount();
        this.GetTotalApplicationCount();
        this.GetApprovedApplicationCount();
        this.GetTotalScheme();
        this.GetTotalFeedback();
        this.getSchemeWiseCount();
    },
    methods: {
        async setChartData() {
            return {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: [
                            "#4caf50", "#f44336", "#2196f3", "#ff9800", "#9c27b0",
                            "#00bcd4", "#ffc107", "#e91e63", "#3f51b5", "#8bc34a",
                            "#673ab7", "#009688", "#cddc39", "#ff5722", "#607d8b",
                            "#795548", "#ffeb3b", "#03a9f4", "#e65100", "#1b5e20"
                        ],
                        hoverBackgroundColor: [
                            "#81c784", "#ef5350", "#64b5f6", "#ffb74d", "#ba68c8",
                            "#4dd0e1", "#ffd54f", "#f06292", "#7986cb", "#aed581",
                            "#9575cd", "#4db6ac", "#dce775", "#ff8a65", "#90a4ae",
                            "#a1887f", "#fff176", "#4fc3f7", "#ef6c00", "#388e3c"
                        ]
                    }
                ]
            };
        },
        async setChartOptions() {
            return {
                plugins: {
                    legend: {
                        position: 'right',
                        labels: {
                            usePointStyle: true,
                            color: "Black"
                        }
                    }
                }
            };
        },
        Go: function (path) {
            this.$router.push(path);
        },
        getSchemeWiseCount: function () {
            var data = {
                lang: this.$i18n.locale,
            };
            var promise = apis.getSchemeWiseCount(data, this.id);
            promise.then((response) => {
                this.SchemeList = response.data.data;
                var temp = this.SchemeList;
                var labels = [];
                var counts = [];
                for (let index = 0; index < temp.length; index++) {
                    var sname = temp[index]['scheme_name'] + " (" + temp[index]['application_count'] + ")";
                    labels.push(sname);
                    counts.push(temp[index]['application_count']);
                }
                //console.log(this.chartData.datasets);
                this.chartData.labels = labels;
                this.chartData.datasets[0]['data'] = counts;
            });
        },
        GetTotalFeedback: function () {
            var data = {
                client_id: localStorage.getItem("client_id"),
                status: "",
                search: "",
                count: true,
            };
            var promise = apis.listFeedback(data, this.id);
            promise.then((response) => {
                this.TotalFeedback = response.data.data;
            });
        },
        GetApprovedApplicationCount: function () {
            var data = {
                client_id: localStorage.getItem("client_id"),
                count: true,
                status:"686b62d95161269389ab6488"
            };
            var promise = apis.schemeapplicationlist(data, this.id);
            promise.then((response) => {
                this.ApprovedApplicationCount = response.data.data;
            });
        },
        GetTotalApplicationCount: function () {
            var data = {
                client_id: localStorage.getItem("client_id"),
                count: true,
            };
            var promise = apis.schemeapplicationlist(data, this.id);
            promise.then((response) => {
                this.TotalApplicationCount = response.data.data;
            });
        },
        GetPendingApplicationCount: function () {
            var data = {
                client_id: localStorage.getItem("client_id"),
                role_id: localStorage.getItem("role_id"),
                count: true,
            };
            var promise = apis.pendingschemeapplicationlist(data, this.id);
            promise.then((response) => {
                this.PendingApplicationCount = response.data.data;
            });
        },
        GetTotalScheme: function () {
            var data = {
                client_id: localStorage.getItem("client_id"),
                status: "",
                search: "",
                count: true,
                AsOnDate: "",
            };
            var promise = apis.listScheme(data, this.id);
            promise.then((response) => {
                this.TotalScheme = response.data.data;
            });
        },
    },
};
</script>